<template>
    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" class="page-title d-flex align-items-center flex-wrap mb-4 mb-lg-0">
        <h1 class="text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
        <span class="h-20px border-gray-300 border-start mx-4"></span>
        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 d-flex flex-wrap">
            <li v-for="(bread, key) in breads" :key="key" class="breadcrumb-item" :class="{'text-muted': key + 1 !== breads.length, 'text-primary': key + 1 === breads.length}">
                <router-link v-if="key + 1 !== breads.length" :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                <span v-if="key + 1 !== breads.length" class="bullet bg-gray-200 w-5px h-2px m-2"></span>
                <span v-else>{{ $t(bread.name) }}</span>
            </li>
        </ul>
    </div>
</template>

<script setup>
import {defineProps} from 'vue'

const props = defineProps({
    title: {
      type: String,
      required: true
    },
    breads: {
      type: Object,
      default: {}
    },
})
</script>